import React from "react"
import FormFields from "../questionnaire/template_reader/FormFields"
import Ajax from "../../../Ajax"
import { Alert } from "../../.."
import { LinearProgress } from "@mui/material"
import { Template } from "../../../models/Interfaces"
import { store } from "../../../stores/Store"
import { SelectOption } from "../../form/fields/SelectField"
import Field from "../../form/fields/Field"

export default function TemplateSettingsForm ({templateUid}) {

    const [loading, setLoading] = React.useState(true)
    const [loadingDefaultSettings, setLoadingDefaultSettings] = React.useState(true)
    const [advisorUid, setAdvisorUid] = React.useState(store.NodeStore.account.advisorUid)
    const [template, setTemplate] = React.useState<Template>(null)
    const [templateBody, setTemplateBody] = React.useState<any>(null)
    const [defaultSettings, setDefaultSettings] = React.useState<any>({})

    const advisorOptions: SelectOption[] = store.NodeStore.accounts.map(account => {
        return {value: account.advisorUid, label: account.accountName}
    })
    
    const submit = async (answers) => {
        await Ajax.QuestionnaireTemplate.SetDefaultSettings(template.key, advisorUid, answers).then((response) => {
            store.AlertStore.Close()
        }).catch((response) => {
            Alert({message: response.data?.detail ? response.data.detail : "Failed to get template default settings"})
        })  
    }

    const loadTemplate = async () => {
        setLoading(true)

        await Ajax.QuestionnaireTemplate.Get(templateUid).then(async (response) => {
            setTemplate(response.data)
            setTemplateBody(JSON.parse(response.data.json))
            loadSettings(response.data.uid, advisorUid)
        }).catch((response) => {
            Alert({message: response.data?.detail ? response.data.detail : "Failed to get template details"})
        })

        setLoading(false)
    }

    const loadSettings = async (templateUid, advisorUid) => {
        setLoadingDefaultSettings(true)
        setDefaultSettings({})

        await Ajax.QuestionnaireTemplate.GetDefaultSettings(templateUid, advisorUid).then((response) => {
            setDefaultSettings(response.data.settings)
        }).catch((response) => {
            Alert({message: response.data?.detail ? response.data.detail : "Failed to get template default settings"})
        })  

        setLoadingDefaultSettings(false)
    }

    React.useEffect(() => {
        loadTemplate()
    }, [])

    if (loading) return <LinearProgress />

    if (!templateBody.settings?.fields) return <p>This Template has not settings section.</p>

    return (
        <div className="form">
            <h2>Default Settings</h2>

            <p>Here you can choose custom default settings for all of your '{template.displayName}' Questionnaires.</p>

            {advisorOptions.length > 1 ? (
                <Field.Select 
                    formik 
                    value={advisorUid} 
                    options={advisorOptions} 
                    onChange={(e) => {
                        setAdvisorUid(e.target.value)
                        loadSettings(template.uid, e.target.value)
                    }} />
            ) : null}
            
            {!loadingDefaultSettings ? (
                <FormFields 
                    initialValues={defaultSettings}
                    fields={templateBody.settings.fields} 
                    onCancel={() => store.AlertStore.Close()}
                    onSubmit={async (settingsAnswers) => {
                        await submit(settingsAnswers)
                    }} />
            ) : (
                <p>Loading the default settings for this template and account.</p>
            )}
        </div>
    )
}